import { Context } from '@nuxt/types';
import axios, { AxiosInstance } from 'axios';

/**
 * Create a configured Axios instance for API services
 * Automatically handles authentication tokens and error responses
 *
 * @param baseURL - The base URL for the API service
 * @param context - Nuxt context for accessing auth and other plugins
 * @param timeout - Request timeout in milliseconds (default: 30000)
 * @returns Configured AxiosInstance
 */
export function createApiInstance(
  baseURL: string,
  context: Context,
  timeout: number = 30000
): AxiosInstance {
  const instance = axios.create({
    baseURL,
    timeout
  });

  // Request interceptor - automatically add Authorization header
  instance.interceptors.request.use(
    (config) => {
      const token = context.$auth.getToken('local');
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor - handle errors globally
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
}
